import client from "../api/client";
export const getList = () => {
  return client('/api/user-representatives').then(({ data }) => data.data);
};

export const getDetail = (id) => {
  return client(`/api/user-representatives/${id}`).then(({ data }) => data.data);
};

export const addEditModel = (values= {}, id=null) => {
  if (id){
    return client(`/api/user-representatives/${id}`, {method: 'put', body: values}).then(({ data }) => data.data);
  } else {
    return client('/api/user-representatives', {method: 'post', body: values}).then(({ data }) => data.data);
  }
};

export const delModel = (id) => {
    return client(`/api/user-representatives/${id}`, {method: 'delete'}).then(({ data }) => data.data);
};

export function useUserRepresentativeService () {
  return {
    getList,
    addEditModel,
    getDetail,
    delModel,
  };
}
